import { Plus, Trash2 } from "lucide-react";
import React from "react";
import { Button } from "../../../ui/buttons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../ui/table";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { dateValue, SectionTitle } from "../EmployeeForm";
import { toIST } from "../../../utils/calculateMargin";
import { useSelector } from "react-redux";

function ReportingManager({
  managerHistory,
  setManagerHistory,
  updateArray,
  removeArrayItem,
}) {
  const { managerOptions } = useSelector((state) => state.employee);
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Reporting Manager Details</SectionTitle>

      <div className="w-full overflow-x-auto border rounded-md mt-2">
        <Table className="min-w-[1000px]">
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>From *</TableHead>
              <TableHead>To</TableHead>
              <TableHead>Manager *</TableHead>
              <TableHead className="text-right">Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {managerHistory.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Calendar
                    value={dateValue(item.fromDate)}
                    onChange={(e) =>
                      updateArray(
                        setManagerHistory,
                        index,
                        "fromDate",
                        toIST(e.value),
                      )
                    }
                    showIcon
                    dateFormat="dd/mm/yy"
                    placeholder="From"
                    className="w-full bg-input border border-gray-300 rounded-md"
                    inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell>
                  <Calendar
                    value={dateValue(item.toDate)}
                    onChange={(e) =>
                      updateArray(
                        setManagerHistory,
                        index,
                        "toDate",
                        toIST(e.value),
                      )
                    }
                    showIcon
                    dateFormat="dd/mm/yy"
                    placeholder="To / Current"
                    className="w-full bg-input border border-gray-300 rounded-md"
                    inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell>
                  <Dropdown
                    value={item.reportingManager}
                    options={managerOptions}
                    onChange={(e) =>
                      updateArray(
                        setManagerHistory,
                        index,
                        "reportingManager",
                        e.value,
                      )
                    }
                    placeholder="Select Manager"
                    filter
                    className="w-full px-1 text-sm border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell className="text-right">
                  <Button
                    type="button"
                    variant="ghost"
                    disabled={managerHistory.length === 1}
                    onClick={() => removeArrayItem(setManagerHistory, index)}
                  >
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          setManagerHistory((prev) => [
            ...prev,
            {
              fromDate: null,
              toDate: null,
              reportingManager: "",
            },
          ])
        }
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add Reporting Manager
      </Button>
    </section>
  );
}

export default ReportingManager;
